import { getCategoryList, getCategoryTop10, getBrandList } from '@/api/common/category';
import _orderBy from 'lodash/orderBy';

export default {
	state: {
		/**
		 * 카테고리 목록
		 * @example
		 * [
		 *   {
		 *     "categoryImgActive": "https://biz.giftishow.com/files/BBS_20190531014113156.png",
		 *     "imgAltText": "커피/음료",
		 *     "categorySeq": 1,
		 *     "sort": 1,
		 *     "categoryName": "커피/음료",
		 *     "categoryImg": "https://biz.giftishow.com/files/BBS_20190531014113130.png"
		 *   }
		 * ]
		 */
		categoryList: [],
		/**
		 * Top10 카테고리 목록
		 * @example
		 * [
		 *   {
		 *     "categoryImgActive": "https://biz.giftishow.com/files/BBS_20190531014113156.png",
		 *     "imgAltText": "커피/음료",
		 *     "categorySeq": 1,
		 *     "sort": 1,
		 *     "categoryName": "커피/음료",
		 *     "categoryImg": "https://biz.giftishow.com/files/BBS_20190531014113130.png"
		 *   }
		 * ]
		 */
		categoryTop10: [],
		/**
		 * 브랜드 목록
		 * @example
		 * [
		 *   {
		 *     "brandName": "스타벅스",
		 *     "brandSeq": 696,
		 *     "category1Name": "커피/음료",
		 *     "sort": 0,
		 *     "content": "",
		 *     "brandBannerImg": "https://biz.giftishow.com/Resource/brand/BR_20140729_174613_1.jpg",
		 *     "mmsThumImg": "https://biz.giftishow.com/Resource/brand/BR_20140515_110327_4.png",
		 *     "category2Seq": 0,
		 *     "brandIConImg": "https://biz.giftishow.com/Resource/brand/BR_20140605_164826_3.jpg",
		 *     "category2Name": null,
		 *     "newFlag": "N",
		 *     "category1Seq": 1,
		 *     "popular": 35270,
		 *     "brandCode": "BR00007"
		 *   }
		 * ]
		 */
		brandList: [], // 인기순 브랜드 정렬(기본)
		brandNameList: [], // 이름순 브랜드 정렬(선택)
	},
	mutations: {
		SET_CATEGORY_LIST: (state, categoryList) => {
			state.categoryList = categoryList;
		},
		SET_CATEGORY_TOP10: (state, categoryList) => {
			state.categoryTop10 = categoryList;
		},
		SET_BRAND_LIST: (state, brandList) => {
			state.brandList = brandList;
		},
		SET_BRAND_NM_LIST: (state, brandList) => {
			state.brandNameList = brandList;
		},
	},
	actions: {
		async fetchCategoryList({ commit }) {
			try {
				const response = await getCategoryList({});
				if (response.code !== 'SUC0000') throw new Error(response.message);

				commit('SET_CATEGORY_LIST', response.result.resultList);
			} catch (error) {
				console.error('[fetchCategoryList]', error);
			}
		},

		async fetchTop10CategoryList({ commit }) {
			try {
				const response = await getCategoryTop10({});
				if (response.code !== 'SUC0000') throw new Error(response.message);

				commit('SET_CATEGORY_TOP10', response.result.resultList);
			} catch (error) {
				console.error('[fetchTop10CategoryList]', error);
			}
		},

		async fetchBrandList({ commit }, payload = { lineUp: 'popular' }) {
			try {
				const response = await getBrandList({ lineUp: payload.lineUp });
				if (response.code !== 'SUC0000') throw new Error(response.message);

				if (payload.lineUp === 'name') {
					commit('SET_BRAND_NM_LIST', response.result.resultList);
				} else {
					commit('SET_BRAND_LIST', response.result.resultList);
				}
			} catch (error) {
				console.error('[fetchBrandList]', error);
			}
		},
	},
	getters: {
		categoryList: state => state.categoryList,
		categoryListUpTo12: state => state.categoryList?.slice(0, 12),
		categoryTotalCount: state => state.categoryList?.length ?? 0,
		popularCategoryList: state => state.categoryTop10,
		brandList: state => state.brandList, // 기본 정렬 popular
		brandBest10: state => _orderBy(state.brandList, 'popular', 'desc').slice(0, 10),
		brandBest12: state => _orderBy(state.brandList, 'popular', 'desc').slice(0, 12),
		brandMap: state =>
			state.categoryList.reduce(
				(map, category) => ({
					...map,
					[category.categorySeq]: state.brandList.filter(brand => brand.categoryList[0] === category.categorySeq),
				}),
				{}
			),
	},
};
